import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useRecoilState } from "recoil";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import AlertModal from "../../../../Modal/AlertModal";
import DefaultModalLayout, {
  defaultModalType,
} from "../../../../Modal/DefaultModalLayout";
import { HasInitValueBox } from "../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import TargetContainer, {
  ModalLabel,
} from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { IPopupNotiSave } from "../PopupNotiInfo";
import PopupNotiDeleteModal from "./PopupNotiDeleteModal";
import NotiRegistAlertModal from "./PopupNotiModal/NotiRegistAlertModal";
import PopupActSection from "./PopupNotiModal/PopupActSection";
import PopupPreviewSection from "./PopupNotiModal/PopupPreviewSection";
import PopupTemplateSection from "./PopupNotiModal/PopupTemplateSection";

interface PopupNotiModalProps extends DefaultModalCommonProps {
  popupData?: IPopupNotiSave;
}

export const popupReasonOption = [
  { value: "1", label: "알림톡 발송 실패" },
  { value: "0", label: "LMS 발송 실패" },
];

export default function PopupNotiModal({
  popupData,
  closeEvent,
  confirmEvent,
  type,
}: PopupNotiModalProps) {
  const [modalType, setModalType] = useRecoilState(defaultModalType);
  const [targetUid, setTargetUid] = useState(popupData ? popupData?.user : ""); // 수신자
  const [getType, setGetType] = useState(false); // 팝업 사유 리스트 가져오기
  const [reasonOptionList, setReasonOptionList] = useState<OptionType[]>([]);

  const [reasonDropdown, setReasonDropdown] = useState<OptionType>({
    value: popupData ? `${popupData?.type}` : "",
    label: popupData ? `${popupData?.typeString}` : "선택",
  }); // 팝업 사유
  const [templateValue, setTemplateValue] = useState<OptionType>({
    value: popupData ? `${popupData?.templateId}` : "",
    label: "선택",
  }); // 팝업 템플릿
  const [previewValue, setPreviewValue] = useState<{
    title: string;
    content: string;
    detail: string;
    buttonName: string;
    buttonLink: string;
  }>({
    title: "",
    content: "",
    detail: "",
    buttonName: "",
    buttonLink: "",
  }); // 템플릿 미리보기
  const [previewBtnValue, setPreviewBtnValue] = useState({
    buttonName: "",
    buttonLink: "",
  });

  const [registerAlertModal, setRegisterAlertModal] = useState(false);
  const [deleteAlertModal, setDeleteAlertModal] = useState(false);
  const [popupNotiDeleteModal, setPopupNotiDeleteModal] = useState(false);
  const [inputData, setInputData] = useState({
    uid: 0,
    type: 0,
    messageid: 0,
    id: 0,
  });

  // 팝업 템플릿 조회
  const {
    response: tempRes,
    error: tempError,
    loading: tempLoading,
  } = useApi({
    method: "get",
    url:
      templateValue?.value !== ""
        ? `popup/message?id=${templateValue?.value}`
        : undefined,
  });

  // 팝업 사유 조회
  const {
    response: typeRes,
    error: typeError,
    loading: typeLoading,
  } = useApi({
    method: "get",
    url: getType ? `popup/type` : undefined,
  });

  useEffect(() => {
    setModalType(type);
  }, [type]);

  useEffect(() => {
    const li: OptionType[] = [];

    if (typeRes?.status === 200) {
      if (typeRes?.data?.length > 0) {
        typeRes?.data?.forEach((a: any) =>
          li.push({
            value: `${a.id}`,
            label: `${a.name}`,
          })
        );

        setReasonOptionList(li);
      }
    }
  }, [typeRes]);

  useEffect(() => {
    if (tempRes?.status === 200) {
      console.log(modalType, tempRes?.data);

      const templateData = tempRes?.data[0];

      setPreviewBtnValue({
        buttonName: templateData?.buttonName,
        buttonLink: templateData?.buttonLink,
      });

      setPreviewValue((prev) => ({
        title:
          popupData && modalType === "view"
            ? `${templateData?.title ?? ""}`
            : popupData && modalType === "edit"
            ? `${templateData?.title ?? ""}`
            : prev?.title !== ""
            ? prev?.title ?? ""
            : "",
        content:
          popupData && modalType === "view"
            ? `${templateData?.content ?? ""}`
            : popupData && modalType === "edit"
            ? `${templateData?.content ?? ""}`
            : prev?.content !== ""
            ? prev?.content ?? ""
            : "",
        detail:
          popupData && modalType === "view"
            ? `${templateData?.detail ?? ""}`
            : popupData && modalType === "edit"
            ? `${templateData?.detail ?? ""}`
            : prev?.detail !== ""
            ? prev?.detail ?? ""
            : "",
        buttonName:
          popupData && modalType === "view"
            ? `${templateData?.buttonName ?? ""}`
            : popupData && modalType === "edit"
            ? `${templateData?.buttonName ?? ""}`
            : prev?.buttonName !== ""
            ? prev?.buttonName ?? ""
            : "",
        buttonLink:
          popupData && modalType === "view"
            ? `${templateData?.buttonLink ?? ""}`
            : popupData && modalType === "edit"
            ? `${templateData?.buttonLink ?? ""}`
            : prev?.buttonLink !== ""
            ? prev?.buttonLink ?? ""
            : "",
      }));

      setTemplateValue({
        value:
          popupData && modalType === "view"
            ? `${popupData?.templateId ?? ""}`
            : templateValue?.value !== ""
            ? templateValue?.value
            : "",
        label:
          popupData && modalType === "view"
            ? `${templateData?.title ?? "선택"}`
            : templateValue?.label !== "선택"
            ? templateValue?.label
            : "선택",
      });
    }
  }, [modalType, tempRes, popupData]);

  useEffect(() => {
    if (typeError || tempError) {
      toast.error(
        tempError?.data ??
          typeError?.data ??
          "팝업 사유 리스트를 가져오는 데에 실패하였습니다."
      );
    }
  }, [typeError, tempError]);

  return (
    <DefaultModalLayout
      modalTitle={
        modalType === "input"
          ? "팝업 등록"
          : modalType === "view"
          ? "팝업 확인"
          : "팝업 수정"
      }
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        if (modalType === "input" || modalType === "edit") {
          setInputData({
            uid: +targetUid?.split("_")[0]!,
            messageid: +templateValue?.value!,
            type: +reasonDropdown?.value!,
            id: popupData?.id ?? 0,
          });
          setRegisterAlertModal(true);
        }
      }}
      type="input"
      confirmBtnText={modalType === "input" ? "등록" : undefined}
      confirmDisabled={
        modalType === "input"
          ? templateValue?.value === "" ||
            !targetUid?.includes("_") ||
            reasonDropdown?.value === ""
          : false
      }
      deleteBtnShow={popupData && modalType !== "input"}
      deleteBtnClickEvent={() => setDeleteAlertModal(true)}
      leftBottomName={popupData?.writer ?? undefined}
    >
      <>
        {/* 처리 여부 */}
        {popupData && (
          <PopupActSection
            modalType={modalType}
            popupAct={popupData?.act}
            popupId={popupData?.id}
            user={targetUid}
            confirmEvent={() => {
              closeEvent();
              if (confirmEvent) confirmEvent();
            }}
          />
        )}

        {/* 수신자 */}
        <TargetContainer
          targetUid={targetUid}
          setTargetUid={setTargetUid}
          modalType={type}
          targetText={"수신자"}
          inputBoxWidth={230}
        />

        {/* 팝업 사유 */}
        <ModalRow>
          <ModalLabel>팝업 사유</ModalLabel>

          <div onClick={() => setGetType(true)}>
            {modalType === "view" ? (
              <HasInitValueBox style={{ width: 230 }}>
                {reasonDropdown?.label}
              </HasInitValueBox>
            ) : (
              <DropDown
                optionList={reasonOptionList}
                dropdownValue={reasonDropdown}
                setDropDownValue={setReasonDropdown}
                boxWidth={230}
                isDisabled={!targetUid?.includes("_")}
              />
            )}
          </div>
        </ModalRow>

        {/* 팝업 템플릿 */}
        <PopupTemplateSection
          type={modalType}
          popupReason={+reasonDropdown?.value!}
          dropdownDisabled={reasonDropdown?.value === ""}
          btnDisabled={templateValue?.value === "" || !targetUid?.includes("_")}
          templateValue={templateValue}
          setTemplateValue={setTemplateValue}
          setPreviewValue={setPreviewValue}
        />

        {/* 팝업 미리보기 */}
        {templateValue?.label !== "선택" && (
          <PopupPreviewSection
            previewValue={previewValue}
            previewBtnValue={previewBtnValue}
          />
        )}
      </>

      <>
        {(tempLoading || typeLoading) && <Loader />}

        {/* 팝업 추가 ask 모달 */}
        {registerAlertModal && (
          <NotiRegistAlertModal
            closeEvent={closeEvent}
            setRegisterAlertModal={setRegisterAlertModal}
            confirmEvent={confirmEvent}
            inputData={inputData}
            modalType={modalType}
          />
        )}

        {deleteAlertModal && (
          <AlertModal
            title={`${targetUid}님의 
          예정된 팝업이 삭제됩니다.
          계속하시겠습니까?`}
            cancelEvent={() => setDeleteAlertModal(false)}
            confirmText="계속"
            confirmEvent={() => {
              setDeleteAlertModal(false);
              setPopupNotiDeleteModal(true);
            }}
          />
        )}
        {popupNotiDeleteModal && (
          <PopupNotiDeleteModal
            closeEvent={() => setPopupNotiDeleteModal(false)}
            confirmEvent={() => {
              closeEvent();
              if (confirmEvent) {
                confirmEvent();
              }
            }}
            popupId={popupData?.id!}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}
